import axios from 'axios';
import {
  API_URL,
  AUTHORISATION_TOKEN_STORAGE_KEY,
  FILE_HOST
} from '../utilities/constants';


const createApiClient = (host) => {
  const apiClient = axios.create({
    baseURL: host,
  });

  /**
   * Inject the token from local storage if it exists, otherwise continue
   * without any Auth token.
   */
  apiClient.interceptors.request.use(
    async (config) => {
      try {
        const token = await localStorage.getItem(AUTHORISATION_TOKEN_STORAGE_KEY);
        return {
          ...config,
          headers: {
            ...config.headers,
            'X-Auth-Token': token || undefined,
          },
        };
      } catch (e) {
        // no token in local storage
        return config;
      }
    },
    (error) => Promise.reject(error),
  );

  /**
   * Global error handling for API calls
   */
  apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const errorResponse = error.response;

      // redirect to root path on 401
      if (errorResponse && errorResponse.status === 401) {
        await localStorage.removeItem(AUTHORISATION_TOKEN_STORAGE_KEY);
        window.location.href = '/';
      }

      return Promise.reject(error);
    },
  );

  return apiClient
}

const apiClient = createApiClient(API_URL)
const fileApiClient = createApiClient(FILE_HOST)

const { get, post, put, delete: destroy } = apiClient;
const { get: getFile, post: postFile, put: putFile, delete: destroyFile} = fileApiClient
export { get, post, put, destroy , getFile, postFile, putFile, destroyFile};
